<template>
  <form @submit.stop.prevent="adjustStock">
    <div class="my-5">
      <label>Product</label>
      <input
          v-model="stock.productName"
          readonly disabled
          class="form-control"
      />
    </div>
    <div class="my-5">
      <label>Expiry Date [Shipment]</label>
      <multiselect v-model="stock.shipmentId" :options="stock.shipments" :class="{
                        'is-invalid': v$.stock.shipmentId.$error,
                  }" class="multiselect-height-3" placeholder="Select one" :custom-label="customLabel" track-by="orderId">
      </multiselect>
      <p
          v-for="error in v$.stock.shipmentId.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-5">
      <label>Stock Operation</label>
      <multiselect v-model="stock.adjustmentType" :options="stockAdjustmentOperations" :class="{
                        'is-invalid': v$.stock.adjustmentType.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name">
      </multiselect>
      <p
          v-for="error in v$.stock.adjustmentType.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-5">
      <label>Quantity</label>
      <input
          v-model="stock.quantity"
          name="name"
          type="number"
          min="0"
          class="form-control"
          :class="{
            'is-invalid': v$.stock.quantity.$error,
          }"
      />
      <p
          v-for="error of v$.stock.quantity.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-5">
      <label>Adjustment Date</label>
      <date-picker v-model="stock.dateOrdered" format="YYYY-MM-DD" valueType="format" :class="{
                        'is-invalid': v$.stock.dateOrdered.$error,
                  }"></date-picker>
      <p
          v-for="error of v$.stock.dateOrdered.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-5">
      <label>Description</label>
      <textarea
          v-model="stock.description"
          class="form-control"
          :class="{
            'is-invalid': v$.stock.description.$error,
          }"
          rows="5"
      ></textarea>
      <p
          v-for="error of v$.stock.description.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-2 text-white" disabled v-if="stockLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-2 text-white" type="submit" v-else>Adjust Stock</b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";
import Multiselect from "vue-multiselect";
import {STOCK_ADJUSTMENT_OPERATIONS} from "@/gql";
import moment from 'moment'

export default {
  name: "adjust-stock-modal",
  components: {Multiselect},
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      stock: this.stockInfo,
      stockAdjustmentOperations: []
    }
  },
  apollo: {
    stockAdjustmentOperations: {
      query: STOCK_ADJUSTMENT_OPERATIONS
    }
  },
  props: {
    stockInfo: {
      type: Object,
      default(){
        return {
          productId: '',
          productName: '',
          shipments: [],
          shipmentId: '',
          quantity: '',
          dateOrdered: '',
          description: '',
          adjustmentType: ''
        }
      }
    }
  },
  validations () {
    return {
      stock: {
        quantity: {required},
        dateOrdered: {required},
        description: {required},
        shipmentId: {required},
        adjustmentType: {required}
      }
    }
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  methods: {
    async adjustStock() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        productId: this.stock.productId,
        shipmentId: this.stock.shipmentId.publicId,
        quantity: parseInt(this.stock.quantity),
        dateOrdered: this.stock.dateOrdered,
        description: this.stock.description,
        adjustmentType: this.stock.adjustmentType.id
      }
      this.$emit('adjustStock', data)
      this.v$.$touch();
    },
    customLabel ({ orderId, expiryDate, warehouseId }) {
      return `${moment(expiryDate).format('DD MMM YYYY')} – ${warehouseId?.name} [${orderId}]`
    }
  }
}
</script>

<style scoped>

</style>
